import murmur3 from "./hash/murmur3";
import ipv4 from "./formats/ipv4";
import number from "./formats/number";

const cmpNumbers = function(left, right) {
    if (left === right) {
        return 0;
    }
    return left < right ? -1 : 1;
};

const MultiSort = function() {
    this._subSorts = [];
};

MultiSort.prototype = {
    map: function(obj) {
        const sorts = this._subSorts;
        let index = sorts.length - 1;

        while (index >= 0) {
            const mapped = sorts[index].map(obj);
            if (mapped !== null) {
                return {
                    "index": index,
                    "mapped": mapped
                };
            }
            index -= 1;
        }
        return null;
    },

    cmpKeys: function(left, right) {
        if (left.index === right.index) {
            return this._subSorts[left.index].cmpKeys(left.mapped, right.mapped);
        }
        return left.index < right.index ? -1 : 1;
    },

    cmpValues: function(left, right) {
        if (left.index === right.index) {
            return this._subSorts[left.index].cmpValues(left.mapped, right.mapped);
        }
        return left.index < right.index ? -1 : 1;
    },

    unmap: function(obj) {
        return this._subSorts[obj.index].unmap(obj.mapped);
    },

    register: function(subSort) {
        if (typeof subSort === "function") {
            subSort = subSort();
        }
        this._subSorts.push(subSort);
        return subSort;
    }
};

const globalSort = new MultiSort();

export default {
    "MultiSort": MultiSort,
    "globalSort": globalSort,

    // The default alphanumeric fallback sort
    "alphaNumeric": globalSort.register(function() {
        const rex = /(\d+)/g;

        const parse = function(key) {
            const split = key.split(rex);
            const length = split.length;

            const parsed = new Array(length);
            for (let i = 0; i < length; i += 2) {
                parsed[i] = split[i].toLowerCase();
                parsed[i + 1] = Number(split[i + 1]);
            }
            return parsed;
        };

        return {
            map: function(obj) {
                return {
                    "hash": murmur3(obj),
                    "parsed": null,
                    "original": obj
                };
            },

            cmpKeys: function(_left, _right) {
                const lHash = _left.hash;
                const rHash = _right.hash;
                if (lHash !== rHash) {
                    return lHash < rHash ? -1 : 1;
                }

                const lKey = _left.original;
                const rKey = _right.original;
                if (lKey !== rKey) {
                    return lKey < rKey ? -1 : 1;
                }
                return 0;
            },

            cmpValues: function(_left, _right) {
                let left = _left.parsed;
                if (left === null) {
                    _left.parsed = left = parse(_left.original);
                }
                let right = _right.parsed;
                if (right === null) {
                    _right.parsed = right = parse(_right.original);
                }

                let length = left.length;
                if (length > right.length) {
                    length = right.length;
                }

                for (let i = 0; i < length; i++) {
                    if (left[i] < right[i]) {
                        return -1;
                    } else if (right[i] < left[i]) {
                        return 1;
                    }
                }

                if (left.length < right.length) {
                    return -1;
                } else if (right.length < left.length) {
                    return 1;
                }

                if (_left.original < _right.original) {
                    return -1;
                } else if (_right.original < _left.original) {
                    return 1;
                }
                return 0;
            },

            unmap: function(value) {
                return value.original;
            }
        };
    }),

    // Numeric sort
    "numeric": globalSort.register(function() {
        return {
            map: function(string) {
                return number.parse(string);
            },

            cmpKeys: cmpNumbers,

            cmpValues: cmpNumbers,

            unmap: function(value) {
                return "" + value;
            }
        };
    }),

    // IPv4
    "ipv4": globalSort.register(function() {
        const cmpIps = function(left, right) {
            return left.cmp(right);
        };

        return {
            map: function(string) {
                return ipv4.parseIP(string);
            },

            cmpKeys: cmpIps,

            cmpValues: cmpIps,

            unmap: function(mapped) {
                return mapped.format();
            }
        };
    })
};



// WEBPACK FOOTER //
// ./src/abusesa-js/Sorting.js